export default "__VITE_ASSET__CwS9x3es__"